export enum LicenseENUM {
  BASIC = 'BASIC',
  PRO = 'PRO',
  PRO_3MEETS = 'PRO_3MEETS',
  PRO_AUTO = 'PRO_AUTO',
  PROMAX = 'PROMAX',
  ULTRA = 'ULTRA'
}

export enum ModelENUM {
  TISSOT = 'TISSOT',
  HEROLTE = 'HEROLTE'
}
export enum ToolENUM {
  All = 'All',
  OneChanger = 'OneChanger',
  MiChanger = 'MiChanger'
}

export interface License {
  email: string;
  durationInDay: number;
  dateStart: number;
  dateEnd: number;
  serialNo: string;
  transactionDate: number;
  isDisabled: boolean;
  type: LicenseENUM;
  model: ToolENUM;
}

export interface LicenseListResponse {
  licenses: License[];
  total: number;
  currentPage: number;
  totalPages: number;
}

export interface LicenseInput {
  email: string;
  serialNo: string;
  type: LicenseENUM;
  model: ToolENUM;
  durationInDay: number;
  durationDayCustom: number;
  dateStart?: number | null;
  dateEnd?: number | null;
  isNew?: boolean;
}

export interface MutationResponse {
  result: boolean;
  message: string;
}

export interface ExtensionConfirmationResponse extends MutationResponse {
  data: {
    remainingDays: number;
    existingLicense?: License;
  };
}